import { render, staticRenderFns } from "./ItemExtraInfoLayout.vue?vue&type=template&id=5de42846&scoped=true&"
import script from "./ItemExtraInfoLayout.vue?vue&type=script&lang=js&"
export * from "./ItemExtraInfoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de42846",
  null
  
)

export default component.exports